import { Offcanvas } from 'bootstrap';

export default function offCanvasAnchorClose() {
    const offcanvasNav = document.getElementById('header-alt-main-nav');
    if (!offcanvasNav) return;

    const anchorLinks = offcanvasNav.querySelectorAll('a[href^="#"]:not([data-bs-toggle="collapse"])');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', () => {
            const offcanvasInstance = Offcanvas.getInstance(offcanvasNav) || new Offcanvas(offcanvasNav);
            offcanvasInstance.hide();
        });
    });
}